export const types = {

	//TYPES LOGOS
	loadColors: '[Config] Load Colors Platform',
	loadRounded: '[Config] Load Rounded Style Platform',
	loadLogoRegister: '[Config] Load Logo Register',
	loadLogoNavbar: '[Config] Load Logo Navbar',
	loadLogoLogin: '[Config] Load Logo Login',
	loadLogoFooter: '[Config] Load Logo Footer',
	loadBannerPolitics: '[Config] Load Banner Politics',
	loadNavbarColor: '[Config] Load Navbar Color',
	loadBackgroundScreen: '[Config] Load Background Screen Color',
	loadScreenTextColor: '[Config] Load Screen Text Color',
	loadAlertColor: '[Config] Load Alert Color',
	loadAlertTextColor: '[Config] Load Alert Text Color',
	loadBackgroundFooter: '[Config] Load Background Footer',
	loadFooterTextColor: '[Config] Load Footer Text Color',
	loadBgBtnGuardar: '[Config] Load Background BTN Guardar',
	loadTextColorBTNGuardar: '[Config] Load BTN Guardar Texto Color',
	loadBgHooverBtnGuardar: '[Config] Load Background Hoover BTN Guardar',
	loadTextColorHooverBtnGuardar: '[Config] Load Hoover BTN Guardar Texto Color',

	// TYPES URL SALA ESPERA PERITO
	loadUrlPeritoSala: '[Config] Load URL Room Perito',

	//TYPES PARA LA INFORMACIÓN DE LA EMPRESA (FOOTER)
	loadDataInformedConsent: '[Config] Load Data Informed Consent',
	loadDataAssurance: '[Config] Load Data Assurance',
	loadDataRecommendations: '[Config] Load Data Recommendations',
	loadDataTimes: '[Config] Load Data Times',
	loadDataRefund: '[Config] Load Data Refund',
	loadDataRights: '[Config] Load Data Rights',
	loadDataDuties: '[Config] Load Data Duties',
	loadDataFaqs: '[Config] Load Data Faqs',
	loadDataUseOurWebsite: '[Config] Load Data Use Our Website',
	loadDataInformationSecurity: '[Config] Load Data Information Security',
	loadDataUser: '[Config] Load Data User',
	loadDataModifications: '[Config] Load Data Modifications',
	loadDataRestrictions: '[Config] Load Data Restrictions',
	loadDataContents: '[Config] Load Data Contents',
	loadDataGuaranteesResponsabilities: '[Config] Load Data Guarantees Responsabilities',
	loadDataCookies: '[Config] Load Data Cookies',
	loadDataDurationTermination: '[Config] Load Data Duration Termination',
	loadDataUserCompensation: '[Config] Load Data User Compensation',
	loadDataLegislationJurisdiction: '[Config] Load Data Legislation Jurisdiction',
	loadDataProtection: '[Config] Load Data Protection',
	loadDataMexicoPolitics: '[Config] Load Data Mexico Politics',
	loadDataElementsPolitics: '[Config] Load Data Elements Politics',
	loadDataGlossaryTerms: '[Config] Load Data Glossary Terms',
	loadDataPrivacyNoticeMexico: '[Config] Load Data Privacy Notice Mexico',
	loadDataColPolitics: '[Config] Load Data Col Politics',
	loadDataGlossaryCol: '[Config] Load Data Glossary Col',
	loadDataproccesingPersonalData: '[Config] Load Data proccesing Personal Data',
	loadDataRightsHolders: '[Config] Load Data Rights Holders',
	loadDataDutiesTreatment: '[Config] Load Data Duties Treatment',
	loadDataSecurityMeasures: '[Config] Load Data Security Measures',

	//TYPES PARA EL HOME
	loadDataImagesCarousel: '[Config] Load Data Images Carousel',

	//TYPES GENERALES PARA INICIO Y CIERRE DE SESIÓN
	login: '[Auth] Login Saluta',
	loginDoctor: '[Auth] Login Doctor Saluta',
	loadDataProf: '[Citas] Load Data Prof',
	logout: '[Auth] Logout Saluta',
	recover: '[Auth] Recover Password Saluta',
	register: '[Auth] Register User Saluta',
	loadPermissions: '[Auth] Load Permissions',
	clearPermissions: '[Auth] Load Permissions',

	//TYPES PARA EL INICIO Y FINALIZACIÓN DE LA UI
	uiLoadingActionScreen: '[UI] Change State Loading Action Screen',
	uiSetMsgActionScreen: '[UI] Set MSG Loading Action Screen',
	uiStartLoadingScreen: '[UI] Start Loading Screen Saluta',
	uiFinishLoadingScreen: '[UI] Finish Loading Screen Saluta',

	//TYPES DE LOS PACIENTES
	historyLoad: '[Patient] Loading History',
	myDatesPatient: '[Patient] Load My Patient Dates',
	historyActive: '[Patient] Set Active History',
	historyActiveClean: '[Patient] Clean Active History',
	getCode: '[Patient] Get Code Authentication',
	confirmCode: '[Patient] Confirm Code Authentication',
	errorCode: '[Patient] Error Code Authentication',
	cleanDatesPatient: '[Patient] Clean Dates Patient',

	//TYPES DE LOS DOCTORES
	doctorAddNewRecord: '[Doctor] Add New Record',
	doctorUpdateRecord: '[Doctor] Update Record',
	doctorPatientActive: '[Doctor] Set Active Patient',
	doctorPatientActiveClean: '[Doctor] Clean Active Patient',
	doctorAddMedicine: '[Doctor] Add Patient Medicine',
	doctorReloadAddMedicine: '[Doctor] Reload Patient Medicine',
	doctorAddMedicineInUpdate: '[Doctor] Add Patient Medicine for Update',
	doctorRemoveOneMedicine: '[Doctor] Remove One Patient Medicine',
	doctorRemoveAllMedicines: '[Doctor] Remove All Patient Medicines',
	doctorClearMedicines: '[Doctor] Clear Patient Medicines',
	doctorAddDocument: '[Doctor] Add Patient Document',
	doctorRemoveOneDocument: '[Doctor] Remove One Patient Document',
	doctorClearDocuments: '[Doctor] Clear Patient Documents',
	doctorActiveHistoryClean: '[Doctor] Clear Record Patient',
	doctorUpdateMedicine: '[Doctor] Update Patient Medicines',
	doctorLoad: '[Doctor] Load Records',
	myPatientsLoad: '[Doctor] Load My Patients',
	myRecordsLoad: '[Doctor] Load Records of Patients',
	doctorActiveAlertMedicine: '[Doctor] Show Alert Create Medicine',
	doctorActiveAlertOrder: '[Doctor] Show Alert Create Order',
	doctorActiveAlertProcedure: '[Doctor] Show Alert Create Procedure',
	loadCountriesProf: '[Doctor] Load Countries Doctor',

	doctorUpdated: '[Doctor] Updated',
	doctorFileUrl: '[Doctor] Updated File',
	doctorDelete: '[Doctor] Delete',
	doctorLogoutCleaning: '[Doctor] Logout Cleaning',
	myDatesLoad: "[Doctor] Load My Dates",
	myDatesPeritajeLoad: "[Doctor] Load My Dates Peritaje",
	openModalAddRecord: "[Doctor] Open Modal Add Record",
	closeModalAddRecord: "[Doctor] Close Modal Add Record",
	cleanDoctor: '[Doctor] Clean State',

	//TYPES DE LOS PERITOS
	peritoAddNewAudio: '[Perito] Add New Audio',
	peritoAddNewForm: '[Perito] Add New Form',
	updateTimeDoctorPeritaje: '[Perito] Update Time Doctor Perito',
	updateTimePatientPeritaje: '[Perito] Update Time Patient Perito',
	updateTimeEndPeritaje: '[Perito] Update Time End Perito',
	peritoUpdateForm: '[Perito] Update Form Digitador',
	peritoAbsence: '[Perito] Add Absence Patient',
	peritoAttendance: '[Perito] Add Attendance Patient',

	//TYPES DE LOS DIGITADORES
	digitadorChangeStateAudio: '[Digitador] Check Audio Peritaje',
	digitadorAddNewForm: '[Digitador] Add New Form Peritaje',

	//TYPES DEL AGENDADOR DE PERITAJES
	addLinkPeritaje: '[Reserva Perito] Add Link Peritaje',
	resendLink: '[Reserva Perito] Resend Link Peritaje',
	loadDatesPeritaje: '[Reserva Perito] Load Dates Peritaje',
	loadFullDatesPeritaje: '[Reserva Perito] Load Full Dates Peritaje',
	loadActive: '[Reserva Perito] Load Active Peritaje',
	cleanActive: '[Reserva Perito] Clean Active Peritaje',
	cleanDatesPeritaje: '[Reserva Perito] Clean Dates Peritaje',

	//TYPES DEL ADMIN
	userAddNew: '[Users] Add New User',
	usersLoad: '[Users] Load Users',
	usersClean: '[Users] Clean Users',

	addTypeUser: '[Admin] Add Type User',
	deleteTypeUser: '[Admin] Delete Type User',
	updateTypeUser: '[Admin] Update Type User',
	updateUser: '[Admin] Update User',

	addTypeDerivation: '[Admin] Add Type Derivation',
	deleteTypeDerivation: '[Admin] Delete Type Derivation',
	updateTypeDerivation: '[Admin] Update Type Derivation',

	addGender: '[Admin] Add Gender',
	deleteGender: '[Admin] Delete Gender',
	updateGender: '[Admin] Update Gender',

	addCivilState: '[Admin] Add Civil State',
	deleteCivilState: '[Admin] Delete Civil State',
	updateCivilState: '[Admin] Update Civil State',

	addMedicalPlan: '[Admin] Add Medical Plan',
	deleteMedicalPlan: '[Admin] Delete Medical Plan',
	updateMedicalPlan: '[Admin] Update Medical Plan',

	addNivelEducation: '[Admin] Add Nivel Education',
	deleteNivelEducation: '[Admin] Delete Nivel Education',
	updateNivelEducation: '[Admin] Update Nivel Education',

	addCountryResidence: '[Admin] Add Country Residence',
	deleteCountryResidence: '[Admin] Delete Country Residence',
	updateCountryResidence: '[Admin] Update Country Residence',

	addTypeNationality: '[Admin] Add Type Nationality',
	deleteTypeNationality: '[Admin] Delete Type Nationality',
	updateTypeNationality: '[Admin] Update Type Nationality',

	addTypeConsulta: '[Admin] Add Type Consulta',
	deleteTypeConsulta: '[Admin] Delete Type Consulta',
	updateTypeConsulta: '[Admin] Update Type Consulta',

	addDerivation: '[Admin] Add Derivation',
	deleteDerivation: '[Admin] Delete Derivation',
	updateDerivation: '[Admin] Update Derivation',

	// TYPES SCHEDULE
	fullDatesSchedule: '[Admin] load Schedule',

	addSpecialtySchedule: '[Admin] Add SpecialtySchedule',
	deleteSpecialtySchedule: '[Admin] Delete SpecialtySchedule',
	updateSpecialtySchedule: '[Admin] Update SpecialtySchedule',

	addServiceSchedule: '[Admin] Add ServiceSchedule',
	deleteServiceSchedule: '[Admin] Delete ServiceSchedule',
	updateServiceSchedule: '[Admin] Update ServiceSchedule',

	addProfessionalSchedule: '[Admin] Add ProfessionalSchedule',
	deleteProfessionalSchedule: '[Admin] Delete ProfessionalSchedule',
	updateProfessionalSchedule: '[Admin] Update ProfessionalSchedule',
	blockProfessionalSchedule: '[Admin] Block ProfessionalSchedule',

	// TYPES INTEGRANTES SALUTA
	loadServices: '[Professional] Load Services Saluta',
	loadCivilStates: '[Professional] Load Civil States Saluta',
	loadMedicalPlanes: '[Professional] Load Medical Planes Saluta',
	loadEducationLevels: '[Professional] Load Education Levels Saluta',
	loadGenders: '[Professional] Load Genders Saluta',
	doctorClearServices: '[Professional] Load Services Saluta',
	clearServices: '[Professional] Load Services Saluta',
	clearCivilStates: '[Professional] Load Services Saluta',
	clearMedicalPlanes: '[Professional] Load Services Saluta',
	clearEducationLevels: '[Professional] Load Services Saluta',
	clearGenders: '[Professional] Clear Gender Saluta',
	loadChatProfessional: '[Professional] Load Chat Professional Saluta',
	clearChatProfessional: '[Professional] Clear Chat Professioanl Saluta',
	loadChatCustomer: '[Customer Care] Load Chat Customer Care Saluta',
	clearChatCustomer: '[Customer Care] Clear Chat Customer Care Saluta',
	loadUsersMobile: '[Professional] Load Users Chat Saluta',
	clearUsersMobile: '[Professional] Clear Users Chat Saluta',
	loadProfessionalMobile: '[Professional] Load Professional Chat Saluta',
	clearProfessionalMobile: '[Professional] Clear Professional Chat Saluta',

	//TYPES DE ATENCIÓN AL CLIENTE
	loadReferrals: '[Customer Care] Load Referrals Saluta',
	loadPatients: '[Customer Care] Load Patients Saluta',
	loadStateDervCtrl: '[Customer Care] Load States Derivation/Control',
	createPatient: '[Customer Care] Create Patient Saluta',
	updatePatient: '[Customer Care] Update Patient Saluta',

	//TYPES DASHBOARD
	loadAppointmentsDashboard: '[Dashboard] Load Schedule Dashboard',
	clearDashboardReducer: '[Dashboard] Clear Dashboard Reducer',

	//TYPES FILE MANAGER
	createFolder: '[FILES] Create Folder',
	addFolders: '[FILES] Add Folders',
	removeFolder: '[FILES] Remove Folder',
	setLoadingFolders: '[FILES] Loading Folders',
	changeFolder: '[FILES] Change Folder',
	addFiles: '[FILES] Add Files',
	createFile: '[FILES] Create File',
	removeFile: '[FILES] Remove File',

	//TYPES COMPANY
	loadedCompany: '[Company] Company Loaded in Platform',
	clearLoadedCompany: '[Company] Clear Company Loaded in Platform',
	loadCompanyPermissions: '[Company] Load Permissions Platform',
	clearCompanyPermissions: '[Company] Clear Permissions Loaded Platform',
	loadCompanyPermissionsRoutes: '[Company] Load Permissions Routes Platform',
	clearCompanyPermissionsRoutes: '[Company] Clear Routes Permissions Loaded Platform',
	loadCompanyPermissionsIntegrations: '[Company] Load Permissions Integrations Platform',
	clearCompanyPermissionsIntegrations: '[Company] Clear Integrations Permissions Loaded Platform',
	loadCompanyTagsManager: '[Company] Load Tags Manager Platform',
	clearCompanyTagsManager: '[Company] Clear Tags Manager Loaded Platform',
	loadCompanyResources: '[Company] Load Resources Platform',
	clearCompanyResources: '[Company] Clear Resources Loaded Platform',
	loadCompanyDocumentFooter: '[Company] Load Document Footer Platform',
	clearLoadedDocumentFooter: '[Company] Clear Document Footer Loaded in Platform',
	companyInstance: '[Company] Load Instance DB Platform',
	clearCompanyInstance: '[Company] Clear Instance DB Platform',
	clearPermissionsUser: '[Company] Clear Permissions User Loged',
}